import React from 'react'
import PropTypes from 'prop-types'

import { Box, Typography } from '@material-ui/core'

class ActiveCell extends React.Component {
  render() {
    return this.props.record.Active ? (
      <Box color="success.main">
        <Typography
          variant="body2"
          color="inherit"
        >
          Active
        </Typography>
      </Box>
    ) : (
      <Box color="error.dark">
        <Typography
          variant="body2"
          color="inherit"
        >
          Inactive
        </Typography>
      </Box>
    )
  }
}

ActiveCell.propTypes = {
  record: PropTypes.object.isRequired,
}

export default ActiveCell
